import { nothing, TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";
import { calloutTemplate } from "@/callout";
import { DodonaElement } from "@/components/meta/dodona_element";
import { I18n } from "@/i18n/i18n";
import { resultReadyMessage, SubmissionStatus } from "@/submission_status";

/**
 * Callout showing that a submission finished judging while the user was viewing another
 * submission, so the result was not opened automatically. d-handin-card sets `submission`
 * when that happens and clears it when the result is opened or a new submission is handed in.
 * d-handin-announcer speaks the same message, so this is not a live region.
 *
 * @element d-result-notice
 *
 * @prop {SubmissionStatus|null} submission - The freshly judged submission, or null to hide.
 *
 * @fires view-result - When the user asks to open the result
 */
@customElement("d-result-notice")
export class ResultNotice extends DodonaElement {
    @property({ type: Object })
    submission: SubmissionStatus | null = null;

    private viewResult(): void {
        this.dispatchEvent(new CustomEvent("view-result", { bubbles: true }));
    }

    render(): TemplateResult | typeof nothing {
        if (!this.submission) {
            return nothing;
        }

        return calloutTemplate({
            type: "info",
            icon: "bell-outline",
            title: I18n.t("js.handin.result_ready_title"),
            message: resultReadyMessage(this.submission.status),
            action: {
                label: I18n.t("js.handin.result_ready_view"),
                onClick: () => this.viewResult(),
            },
        });
    }
}
